import kr from 'Kr/kr';
import HTMLCLass from '../../kr/utils/HTMLClass';

export default class Faq extends kr.Component {
    init() {
        this.items = this.$element.querySelectorAll('[data-faq-item]');

        this.bind();
    }

    bind() {
        this.on('click', '[data-faq-item-selector]', (target, event) => {
            event.preventDefault();
            const parent = this._findParent(target);
            this._changeElement(parent);

        });
    }


    
    _changeElement(activeItem) {
        for (let item of this.items) {
            if (item != activeItem) {
                HTMLCLass.removeClass(item, 'active');
                HTMLCLass.removeClass(item, 'active--animated');
                continue;
            } else if (item == activeItem && HTMLCLass.hasClass(item, 'active--animated')) {
                continue;
            }

            HTMLCLass.addClass(item, 'active');
            setTimeout(() => {
                HTMLCLass.addClass(item, 'active--animated');
            },20);
        }
    }
    
    _findParent(el) {
        const parent = el.parentNode;
        if (!parent.hasAttribute('data-faq-item')) {
            return this._findParent(parent);
        }

        return parent;
    }
}

kr.registerComponent('.js-faq', {
    component: Faq
});